module.exports={
    "-notificacao_marcarNaoLido": {
        "id": "-notificacao_marcarNaoLido",
        "eventName": "marcar_nao_lido",
        "eventProduct": "Notificacao",
        "eventCategory": "Notificacao",
        "eventAction": "Clique para deixar a notificação com status de não lido",
        "eventValue": 0.0
    },
    "notificacao_clique": {
      "id": "notificacao_clique",
      "eventName": "clique_notificacao",
      "eventProduct": "Notificacao",
      "eventCategory": "Notificacao",
      "eventAction": "Clique para visualizar o item da notificação",
      "eventValue": 0.0
    },
    "vex_home_notif_icon_exibir": {
        "id": "vex_home_notif_icon_exibir",
        "eventName": "Clickar em notificações",
        "eventProduct": "Notificacao",
        "screenName": "Home",
        "eventCategory": "Notificacao",
        "component": "Card",
        "eventAction": "Click",
        "eventValue": 0
    },
    "vex_home_notif_todas": {
        "id": "vex_home_notif_todas",
        "eventName": "Visualizar todas as notificações",
        "eventProduct": "Notificacao",
        "screenName": "Home",
        "eventCategory": "Notificacao",
        "component": "Card",
        "eventAction": "Click",
        "eventValue": 0
    },
    "vex_home_notif_acoes": {
        "id": "vex_home_notif_acoes",
        "eventName": "Visualizar ações necessárias",
        "eventProduct": "Notificacao",
        "screenName": "Home",
        "eventCategory": "Notificacao",
        "component": "Card",
        "eventAction": "Click",
        "eventValue": 0
    },
    "vex_home_notif_outras": {
        "id": "vex_home_notif_outras",
        "eventName": "Visualizar outras",
        "eventProduct": "Notificacao",
        "screenName": "Home",
        "eventCategory": "Notificacao",
        "component": "Card",
        "eventAction": "Click",
        "eventValue": 0
    },
    "vex_home_notif_despesas": {
        "id": "vex_home_notif_despesas",
        "eventName": "Visualizar minhas despesas",
        "eventProduct": "Notificacao",
        "screenName": "Home",
        "eventCategory": "Notificacao",
        "component": "Card",
        "eventAction": "Click",
        "eventValue": 0
    },
    "vex_home_notif_item": {
        "id": "vex_home_notif_item",
        "eventName": "Visualizar item",
        "eventProduct": "Notificacao",
        "screenName": "Home",
        "eventCategory": "Notificacao",
        "component": "Card",
        "eventAction": "Click",
        "eventValue": 0
    }
}
